export default "__VITE_ASSET__CmxUshtH__"